import { IconButton, Badge } from '@mui/material'
import { useGetProcedureInvitations } from 'hooks/useProcedure';
import { useGetInvitations } from 'hooks/useUsers';
import { useGetUnreadNotificationsCount } from 'hooks/useNotifications';
import { useAuth } from 'context/AuthContext';
import BellIcon from 'icons/BellIcon';
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles'
import { addRefetchListener } from 'services/appNotificationsService';

export default function HeaderNotificationsButton() {
  const navigate = useNavigate();
  const globalStyles = useGlobalStyles();
  const { user } = useAuth();

  const { data: procedureData, refetch: refetchProcedure } = useGetProcedureInvitations();
  const { data: dashboardData, refetch: refetchDashboard } = useGetInvitations(user.id);
  const { data: unreadData, refetch: refetchUnread } = useGetUnreadNotificationsCount();

  const procedureCount = procedureData?.data?.results?.length ?? 0;
  const dashboardCount = dashboardData?.doctors?.length ?? 0;
  const unreadNotificationsCount = unreadData?.data?.count ?? 0;
  const hasNotifications = (procedureCount + dashboardCount + unreadNotificationsCount) > 0;

  useEffect(() => {
    return addRefetchListener('refetchInvitations', () => {
      refetchProcedure();
      refetchDashboard();
    });
  }, [refetchProcedure, refetchDashboard]);

  useEffect(() => {
    return addRefetchListener('refetchNotificationsCount', () => {
      refetchUnread().then((result) => {
        console.log('Unread notifications count:', result.data?.data?.count);
      });
    });
  }, [refetchUnread]);

  // Discussion notes use their own event (so an open notes view can live-refresh)
  // but should still bump the bell badge like every other notification.
  useEffect(() => {
    return addRefetchListener('refetchDiscussionNotes', refetchUnread);
  }, [refetchUnread]);

  return (
    <IconButton
      className={globalStyles.headerIconButton}
      onClick={() => navigate('/notifications')}
    >
      <Badge
        color="error"
        variant="dot"
        invisible={!hasNotifications}
      >
        <BellIcon color={colors.primary} />
      </Badge>
    </IconButton>
  );
}
